import "./reactive-element-BDpydG15.js";
import { state as y } from "../beacon-state.d/index.js";
import { m as S } from "./lifecycle-decorators-CUsT9aHq.js";
import { c as T, a as E, b as I } from "./helper-DZFulwV_.js";
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var w = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], F = /* @__PURE__ */ w.join(","), p = typeof Element > "u", f = p ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, d = !p && Element.prototype.getRootNode ? function(a) {
  var t;
  return a == null || (t = a.getRootNode) === null || t === void 0 ? void 0 : t.call(a);
} : function(a) {
  return a == null ? void 0 : a.ownerDocument;
}, A = function a(t, e) {
  var r;
  e === void 0 && (e = !0);
  var i = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "inert"), n = i === "" || i === "true", u = n || e && t && a(t.parentNode);
  return u;
}, N = function(t) {
  var e, r = t == null || (e = t.getAttribute) === null || e === void 0 ? void 0 : e.call(t, "contenteditable");
  return r === "" || r === "true";
}, C = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, x = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || N(t)) && !C(t) ? 0 : t.tabIndex;
}, g = function(t) {
  return t.tagName === "INPUT";
}, R = function(t) {
  return g(t) && t.type === "hidden";
}, D = function(t) {
  var e = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return e;
}, M = function(t, e) {
  for (var r = 0; r < t.length; r++)
    if (t[r].checked && t[r].form === e)
      return t[r];
}, O = function(t) {
  if (!t.name)
    return !0;
  var e = t.form || d(t), r = function(s) {
    return e.querySelectorAll('input[type="radio"][name="' + s + '"]');
  }, i;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    i = r(window.CSS.escape(t.name));
  else
    try {
      i = r(t.name);
    } catch (u) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", u.message), !1;
    }
  var n = M(i, t.form);
  return !n || n === t;
}, L = function(t) {
  return g(t) && t.type === "radio";
}, P = function(t) {
  return L(t) && !O(t);
}, k = function(t) {
  var e, r = t && d(t), i = (e = r) === null || e === void 0 ? void 0 : e.host, n = !1;
  if (r && r !== t) {
    var u, s, l;
    for (n = !!((u = i) !== null && u !== void 0 && (s = u.ownerDocument) !== null && s !== void 0 && s.contains(i) || t != null && (l = t.ownerDocument) !== null && l !== void 0 && l.contains(t)); !n && i; ) {
      var o, v, h;
      r = d(i), i = (o = r) === null || o === void 0 ? void 0 : o.host, n = !!((v = i) !== null && v !== void 0 && (h = v.ownerDocument) !== null && h !== void 0 && h.contains(i));
    }
  }
  return n;
}, b = function(t) {
  var e = t.getBoundingClientRect(), r = e.width, i = e.height;
  return r === 0 && i === 0;
}, U = function(t, e) {
  var r = e.displayCheck, i = e.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var n = f.call(t, "details>summary:first-of-type"), u = n ? t.parentElement : t;
  if (f.call(u, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || r === "legacy-full") {
    if (typeof i == "function") {
      for (var s = t; t; ) {
        var l = t.parentElement, o = d(t);
        if (l && !l.shadowRoot && i(l) === !0)
          return b(t);
        t.assignedSlot ? t = t.assignedSlot : !l && o !== t.ownerDocument ? t = o.host : t = l;
      }
      t = s;
    }
    if (k(t))
      return !t.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return b(t);
  return !1;
}, j = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var e = t.parentElement; e; ) {
      if (e.tagName === "FIELDSET" && e.disabled) {
        for (var r = 0; r < e.children.length; r++) {
          var i = e.children.item(r);
          if (i.tagName === "LEGEND")
            return f.call(e, "fieldset[disabled] *") ? !0 : !i.contains(t);
        }
        return !0;
      }
      e = e.parentElement;
    }
  return !1;
}, q = function(t, e) {
  return !(e.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  A(e) || R(e) || U(e, t) || // For a details element with a summary, the summary element gets the focus
  D(e) || j(e));
}, B = function(t, e) {
  return !(P(e) || x(e) < 0 || !q(t, e));
}, c = function(t, e) {
  if (e = e || {}, !t)
    throw new Error("No node provided");
  return f.call(t, F) === !1 ? !1 : B(e, t);
}, K = Object.defineProperty, V = Object.getOwnPropertyDescriptor, m = (a, t, e, r) => {
  for (var i = r > 1 ? void 0 : r ? V(t, e) : t, n = a.length - 1, u; n >= 0; n--)
    (u = a[n]) && (i = (r ? u(t, e, i) : u(i)) || i);
  return r && i && K(t, e, i), i;
};
const X = () => function(t) {
  let e = class extends t {
    constructor() {
      super(...arguments), this.currentFocusIndex = 0;
    }
    /**
     * This is a Depth First Traversal function used to collect an ordered array of tabbable elements within a bounding parent element.
     * @param rootNode parent HTMLElement that functions as the "bounds" of this function.
     * @returns an ordered array of tabbable HTMLElements that are children or descendants of the shadowRoot of the rootNode.
     */
    findTabbableElements(r, i = c) {
      var s;
      const n = [r], u = [];
      for (; n.length; ) {
        const l = n.pop();
        l && (i(l) && u.push(l), l.childElementCount && Array.from(l.children).reverse().forEach((o) => n.push(o)), (s = l.shadowRoot) != null && s.childElementCount && Array.from(l.shadowRoot.children).reverse().forEach((o) => n.push(o)));
      }
      return u;
    }
    /**
     * function for handling tabbed focussing within an ordered array of focus-trapped HTMLElements.
     * @param event 'Tab' or 'Shift-Tab' Keyboard event that functions as trigger for toggling focus among focus-trapped HTMLElements
     * @param trappingElement parent HTMLElement that functions as the "bounds" of the focus-trap.
     * @param hasTabbableCriteria boolean indicating if the element is navigable with keys
     */
    handleFocusTabbing(r, i, n = c) {
      return this.handleFocus(r, i, T, n);
    }
    /**
     * function for handling arrow key focussing within an ordered array of focus-trapped elements
     * @param event 'Left', 'Right', 'Up' or 'Down' Keyboard events that trigger focus trapping among focus-trapped elements
     * @param trappingElement parent HTMLElement that functions as the "bounds" of the focus-trap.
     * @param hasTabbableCriteria boolean indicating if the element is navigable with keys
     * @returns the focus handler taking key based parameters
     */
    handleFocusArrowKeys(r, i, n = c) {
      return this.handleFocus(r, i, E, n);
    }
    /**
     * function for updating the current focus index based on a new index element that is clicked on within a modal
     * @param newIndexElement the target element that was clicked on within the modal
     * @param trappingElement parent HTMLElement that functions as the "bounds" of the focus-trap.
     * @param hasTabbableCriteria boolean indicating if the element is navigable with keys
     */
    handleClick(r, i, n = c) {
      const u = this.findTabbableElements(i, n);
      for (const s in r)
        for (const l in u)
          if (u[l].getAttribute("id") === r[s].id) {
            const o = +l;
            this.currentFocusIndex = o;
          }
    }
    /**
     * function that focuses the next focusable element within the focus trap based on the passed incrementing function
     * @param event the key event triggering the focus change
     * @param trappingElement parent HTMLElement that functions as the "bounds" of the focus-trap.
     * @param incrementingFunc function that takes a key and a boolean indicating whether shift has been pressed and returns a number to increment by
     * @param hasTabbableCriteria boolean indicating if the element is navigable with keys
     * @returns a number indicating which branch was followed for testing purposes
     */
    handleFocus(r, i, n, u = c) {
      if (r && i) {
        r.preventDefault();
        const s = this.findTabbableElements(i, u), l = s.length;
        if (s.length === 0)
          return 0;
        const o = n(r.key, r.shiftKey);
        return this.currentFocusIndex = I(this.currentFocusIndex, o, l), s[this.currentFocusIndex].focus(), 1;
      }
      return 3;
    }
  };
  return m([
    y()
  ], e.prototype, "currentFocusIndex", 2), e = m([
    S("FocusTrap")
  ], e), e;
};
export {
  X as F
};
